import createReducer from '../../lib/createReducer'

import {
  USER_FOLLOW_FAILURE,
  USER_FOLLOW_REQUEST,
  USER_FOLLOW_SUCCESS,
} from '../actions/userFollowActions'

const applyFollowState = (state, username, following, count) => ({
  items: following
    ? [...state.items.filter(item => item !== username), username]
    : state.items.filter(item => item !== username),
  counts: {
    ...state.counts,
    [username]: Math.max(0, count),
  },
})

export default createReducer({
  items: [],
  counts: {},
}, {
  [USER_FOLLOW_REQUEST]: ({ payload, meta }, state) => {
    const { username, wantFollowing, previousCount } = payload || meta
    const base = Object.prototype.hasOwnProperty.call(state.counts, username)
      ? state.counts[username]
      : previousCount
    const count = wantFollowing ? base + 1 : base - 1
    return applyFollowState(state, username, wantFollowing, count)
  },
  [USER_FOLLOW_SUCCESS]: ({ payload }, state) => applyFollowState(
    state,
    payload.username,
    payload.following,
    payload.followers_count,
  ),
  [USER_FOLLOW_FAILURE]: ({ meta }, state) => {
    const { username, wantFollowing, previousCount } = meta
    return applyFollowState(state, username, !wantFollowing, previousCount)
  },
})
